import React from 'react'
import './App.css'
import {
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Table,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap'

// import data from './data/data.json'

import Condo from './libs/condo'
import NewHome from './libs/newHome'

export default class App extends React.Component {
  state = {
    homesteadExemptionPercentageTowns: [
      'East Providence',
      'Johnston',
      'Lincoln',
      'North Providence',
      'West Greenwich',
      'Woonsocket',
      'Providence',
      'Central Falls'
    ],
    homesteadExemptionFlatTowns: [],
    towns: null,
    incomeLimits: null,
    selectedTown: null, //data.towns[0],
    selectedPropertyType: 'Condo',
    condoResult: null,
    newHomeResult: null,
    grossMonthlyIncome: 0,
    condoContentInsurance: 30,
    condoFee: 0,
    landLeaseFee: 0,
    interestRate: 0
  }

  componentDidMount() {
    fetch('https://raw.githubusercontent.com/rihousing/purchase-price-calculator/master/data.json') //('https://www.rihousing.com/calculator/data.json') //
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          towns: data.towns,
          incomeLimits: data.incomeLimits,
          selectedTown: data.towns[0]
        })
      })
      .catch((err) => console.error(err))
  }

  handlePropertyTypeChange = (event) => {
    this.setState({
      selectedPropertyType: event.target.value,
      condoResult: null
    })
  }

  handleTownChange = (event) => {
    const town = this.state.towns.find((p) => p.town === event.target.value)
    if (town) {
      this.setState(
        {
          selectedTown: town
        },
        (_) => this.calculate()
      )
    }
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.calculate()
    }
  }

  handleOnBlur = () => {
    this.calculate()
  }

  calculate = () => {
    if (this.state.grossMonthlyIncome <= 0) return

    let homesteadExType
    let homestead
    if (
      this.state.homesteadExemptionPercentageTowns.includes(
        this.state.selectedTown.town
      )
    ) {
      homesteadExType = 'percentage'
      homestead = Number(this.state.selectedTown.homestead)
    } else if (
      this.state.homesteadExemptionFlatTowns.includes(
        this.state.selectedTown.town
      )
    ) {
      homesteadExType = 'flat'
      homestead = Number(this.state.selectedTown.homesteadFlat)
    }

    if (this.state.selectedPropertyType === 'Condo') {
      const result = Condo.calculate(
        this.state.grossMonthlyIncome,
        Number(this.state.selectedTown.taxRate),
        this.state.condoContentInsurance,
        this.state.condoFee,
        this.state.landLeaseFee,
        this.state.interestRate,
        homestead,
        homesteadExType
      )

      this.setState({ condoResult: result })
    } else {
      const result = NewHome.calculate(
        this.state.grossMonthlyIncome,
        Number(this.state.selectedTown.taxRate),
        Number(this.state.selectedTown.hazard),
        this.state.landLeaseFee,
        this.state.interestRate,
        homestead,
        homesteadExType
      )

      this.setState({ newHomeResult: result })
    }
  }

  getValue = (prop) => {
    const set =
      this.state.selectedPropertyType === 'Condo'
        ? this.state.condoResult
        : this.state.newHomeResult

    const value = set ? numberWithCommas(set[prop]) : ''
    return value
  }

  handleGrossMonthlyIncomeChange = (event) => {
    this.setState({
      grossMonthlyIncome: Number(event.target.value)
    })
  }

  handleCondoFee = (event) => {
    this.setState({
      condoFee: Number(event.target.value)
    })
  }

  hanldeLandLeaseFee = (event) => {
    this.setState({
      landLeaseFee: Number(event.target.value)
    })
  }

  handleInterestRate = (event) => {
    let rate = Number(event.target.value)
    rate = rate / 100
    this.setState({
      interestRate: rate
    })
  }

  render() {
    if (
      !this.state.incomeLimits ||
      !this.state.towns ||
      !this.state.selectedTown
    ) {
      return (
        <div className="loading">
          <h4>Loading...</h4>
        </div>
      )
    }

    let incomeLimitsTable = this.state.incomeLimits.find((p) =>
      p.towns.includes(this.state.selectedTown.town)
    )

    if (!incomeLimitsTable || incomeLimitsTable.length === 0) {
      incomeLimitsTable = this.state.incomeLimits.find((p) =>
        p.towns.includes('All')
      )
    }

    const percentage_60 = incomeLimitsTable.percentage_60
    // const percentage_70 = incomeLimitsTable.percentage_70
    const percentage_80 = incomeLimitsTable.percentage_80
    const percentage_100 = incomeLimitsTable.percentage_100
    const percentage_115 = incomeLimitsTable.percentage_115
    const percentage_120 = incomeLimitsTable.percentage_120

    return (
      <Container>
        <Row>
          <Col md="6" lg="4">
            <FormGroup>
              <Label for="exampleSelect">Select Property Type</Label>
              <Input
                type="select"
                name="property-type"
                onChange={this.handlePropertyTypeChange}
                value={this.state.selectedPropertyType}
              >
                <option value="Condo">Condo</option>
                <option value="NewHome">Non-Condo</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md="6" lg="4">
            <FormGroup>
              <Label for="exampleSelect">Select Town</Label>
              <Input
                type="select"
                name="town"
                onChange={this.handleTownChange}
                value={this.state.selectedTown.town}
              >
                {this.state.towns.map((item) => (
                  <option key={item.town}>{item.town}</option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md="12" lg="8">
            <Table className="tbl-income-limits" bordered striped size="sm">
              <thead>
                <tr>
                  <th colSpan="6">
                    Gross Monthly Incomes based on HUD income limits
                  </th>
                </tr>
                <tr>
                  <th>Household size of ></th>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">60%</th>
                  <td>{getMonthlyIncomeLimit(percentage_60, 1)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_60, 2)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_60, 3)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_60, 4)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_60, 5)}</td>
                </tr>
                {/* <tr>
                  <th scope="row">70%</th>
                  <td>{getMonthlyIncomeLimit(percentage_70, 1)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_70, 2)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_70, 3)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_70, 4)}</td>
                </tr> */}
                <tr>
                  <th scope="row">80%</th>
                  <td>{getMonthlyIncomeLimit(percentage_80, 1)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_80, 2)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_80, 3)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_80, 4)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_80, 5)}</td>
                </tr>
                <tr>
                  <th scope="row">100%</th>
                  <td>{getMonthlyIncomeLimit(percentage_100, 1)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_100, 2)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_100, 3)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_100, 4)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_100, 5)}</td>
                </tr>
                <tr>
                  <th scope="row">115%</th>
                  <td>{getMonthlyIncomeLimit(percentage_115, 1)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_115, 2)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_115, 3)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_115, 4)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_115, 5)}</td>
                </tr>
                <tr>
                  <th scope="row">120%</th>
                  <td>{getMonthlyIncomeLimit(percentage_120, 1)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_120, 2)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_120, 3)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_120, 4)}</td>
                  <td>{getMonthlyIncomeLimit(percentage_120, 5)}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        <div className="calc-inputs">
          <Row className="calc-input-row">
            <Col sm="8" md="8" lg="5">
              <Label>Gross monthly income</Label>
            </Col>
            <Col sm="4" md="4" lg="3">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="number"
                  onChange={this.handleGrossMonthlyIncomeChange}
                  onBlur={this.handleOnBlur}
                  onKeyPress={this.handleKeyPress}
                ></Input>
              </InputGroup>
            </Col>
          </Row>

          <Row className="calc-input-row">
            <Col sm="8" md="8" lg="5">
              <Label>Max front end debt (=.3 of GMI)</Label>
            </Col>
            <Col sm="4" md="4" lg="3">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.getValue('maxFrontEndDebt')}
                  readOnly
                  type="text"
                ></Input>
              </InputGroup>
            </Col>
          </Row>

          <Row className="calc-input-row">
            <Col sm="8" md="8" lg="5">
              <Label>Taxes (at affordable assessment)</Label>
            </Col>
            <Col sm="4" md="4" lg="3">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.getValue('taxes')}
                  readOnly
                  type="text"
                ></Input>
              </InputGroup>
            </Col>
          </Row>

          {this.state.selectedPropertyType === 'Condo' && (
            <Row className="calc-input-row">
              <Col sm="8" md="8" lg="5">
                <Label>
                  Condo Content Insurance ($30 is the flat monthly insurance
                  estimate)
                </Label>
              </Col>
              <Col sm="4" md="4" lg="3">
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={this.state.condoContentInsurance}
                    readOnly
                    type="text"
                  ></Input>
                </InputGroup>
              </Col>
            </Row>
          )}

          {this.state.selectedPropertyType === 'Condo' && (
            <Row className="calc-input-row">
              <Col sm="8" md="8" lg="5">
                <Label>
                  Condo Fee (make sure it includes hazard insurance)
                </Label>
              </Col>
              <Col sm="4" md="4" lg="3">
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="number"
                    onChange={this.handleCondoFee}
                    onBlur={this.handleOnBlur}
                    onKeyPress={this.handleKeyPress}
                  ></Input>
                </InputGroup>
              </Col>
            </Row>
          )}

          {this.state.selectedPropertyType === 'NewHome' && (
            <Row className="calc-input-row">
              <Col sm="8" md="8" lg="5">
                <Label>Hazard Insurance</Label>
              </Col>
              <Col sm="4" md="4" lg="3">
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={numberWithCommas(
                      Math.round(this.state.selectedTown.hazard)
                    )}
                    readOnly
                    type="text"
                  ></Input>
                </InputGroup>
              </Col>
            </Row>
          )}

          <Row className="calc-input-row">
            <Col sm="8" md="8" lg="5">
              <Label>Land Lease Fee (if applicable)</Label>
            </Col>
            <Col sm="4" md="4" lg="3">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="number"
                  onChange={this.hanldeLandLeaseFee}
                  onBlur={this.handleOnBlur}
                  onKeyPress={this.handleKeyPress}
                ></Input>
              </InputGroup>
            </Col>
          </Row>

          <Row className="calc-input-row">
            <Col sm="8" md="8" lg="5">
              <Label>Private Mortgage Insurance (PMI)</Label>
            </Col>
            <Col sm="4" md="4" lg="3">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.getValue('privateMortgageInsurance')}
                  readOnly
                  type="text"
                ></Input>
              </InputGroup>
            </Col>
          </Row>

          <Row className="calc-input-row">
            <Col sm="8" md="8" lg="5">
              <Label>Max Principal & Interest</Label>
            </Col>
            <Col sm="4" md="4" lg="3">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.getValue('maxPrincipalAndInterest')}
                  readOnly
                  type="text"
                ></Input>
              </InputGroup>
            </Col>
          </Row>

          <Row className="calc-input-row">
            <Col sm="8" md="8" lg="5">
              <Label className="interest-rate">
                <p>Interest Rate (Enter Freddie Mac PMMS Rate)</p>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://www.freddiemac.com/pmms/"
                >
                  Click here for current rate{' '}
                  <i className="fa fa-external-link" aria-hidden="true"></i>
                </a>
              </Label>
            </Col>
            <Col sm="4" md="4" lg="3">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>%</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="number"
                  onChange={this.handleInterestRate}
                  onBlur={this.handleOnBlur}
                  onKeyPress={this.handleKeyPress}
                ></Input>
              </InputGroup>
            </Col>
          </Row>

          <Row className="calc-input-row">
            <Col sm="8" md="8" lg="5">
              <Label className="mpp">Calculated MAXIMUM Purchase Price</Label>
            </Col>
            <Col sm="4" md="4" lg="3">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.getValue('maxPurchasePrice')}
                  readOnly
                  type="text"
                  className="mpp"
                ></Input>
              </InputGroup>
            </Col>
          </Row>

          {(this.state.homesteadExemptionPercentageTowns.includes(
            this.state.selectedTown.town
          ) ||
            this.state.homesteadExemptionFlatTowns.includes(
              this.state.selectedTown.town
            )) && (
            <section className="homestead-exemption">
              <hr />
              {this.state.homesteadExemptionPercentageTowns.includes(
                this.state.selectedTown.town
              ) && (
                <>
                  <Row className="calc-input-row">
                    <Col sm="12">
                      <p className="homestead-intro">This town offers a homestead exemption for owner-occupied properties. See below for the adjusted purchase price for owner-occupied properties.</p>
                    </Col>
                    <Col sm="8" md="8" lg="5">
                      <Label>Homestead EX</Label>
                    </Col>
                    <Col sm="4" md="4" lg="3">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>%</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          value={Math.round(
                            Number(this.state.selectedTown.homestead) * 100
                          )}
                          readOnly
                          type="number"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>

                  <Row className="calc-input-row">
                    <Col sm="8" md="8" lg="5">
                      <Label>Taxed Value</Label>
                    </Col>
                    <Col sm="4" md="4" lg="3">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          value={this.getValue('taxedValue')}
                          readOnly
                          type="text"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>

                  <Row className="calc-input-row">
                    <Col sm="8" md="8" lg="5">
                      <Label>Tax Rate</Label>
                    </Col>
                    <Col sm="4" md="4" lg="3">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>%</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          value={Number(
                            this.state.selectedTown.taxRate * 100
                          ).toFixed(2)}
                          readOnly
                          type="number"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>

                  <Row className="calc-input-row">
                    <Col sm="8" md="8" lg="5">
                      <Label>Actual Monthly Taxes</Label>
                    </Col>
                    <Col sm="4" md="4" lg="3">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          value={this.getValue('actualMonthlyTaxes')}
                          readOnly
                          type="text"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </>
              )}

              {this.state.homesteadExemptionFlatTowns.includes(
                this.state.selectedTown.town
              ) && (
                <Row className="calc-input-row">
                  <Col sm="8" md="8" lg="5">
                    <Label>Homestead EX</Label>
                  </Col>
                  <Col sm="4" md="4" lg="3">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>$</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        value={Math.round(
                          Number(this.state.selectedTown.homesteadFlat)
                        )}
                        readOnly
                        type="number"
                      ></Input>
                    </InputGroup>
                  </Col>
                </Row>
              )}

              <Row className="calc-input-row">
                <Col sm="8" md="8" lg="5">
                  <Label>Tax Relief Monthly</Label>
                </Col>
                <Col sm="4" md="4" lg="3">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>$</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      value={this.getValue('taxReliefMonthly')}
                      readOnly
                      type="text"
                    ></Input>
                  </InputGroup>
                </Col>
              </Row>

              <Row className="calc-input-row">
                <Col sm="8" md="8" lg="5">
                  <Label>New Max Principal & Interest</Label>
                </Col>
                <Col sm="4" md="4" lg="3">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>$</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      value={this.getValue('newMaxPrincipalAndInterest')}
                      readOnly
                      type="text"
                    ></Input>
                  </InputGroup>
                </Col>
              </Row>

              <Row className="calc-input-row">
                <Col sm="8" md="8" lg="5">
                  <Label className="mpp">Maximum Purchase Price - With Homestead Exemption</Label>
                </Col>
                <Col sm="4" md="4" lg="3">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>$</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      value={this.getValue('newMaxPurchasePrice')}
                      readOnly
                      type="text"
                      className="mpp"
                    ></Input>
                  </InputGroup>
                </Col>
              </Row>
            </section>
          )}
        </div>
      </Container>
    )
  }
}

function getMonthlyIncomeLimit(data, houseHold) {
  const item = data.find((p) => p.houseHold === houseHold)
  let result
  if (item) result = `$${numberWithCommas(Math.round(item.limit / 12))}`
  else result = 'Invalid data.'

  return result
}

function numberWithCommas(x) {
  if (!x) return ''
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
